import { render, staticRenderFns } from "./approval_setting.vue?vue&type=template&id=e1b413e8&scoped=true"
import script from "./approval_setting.vue?vue&type=script&lang=js"
export * from "./approval_setting.vue?vue&type=script&lang=js"
import style0 from "./approval_setting.vue?vue&type=style&index=0&id=e1b413e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b413e8",
  null
  
)

export default component.exports